import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Focus = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M3.75 8.00003V5.75003C3.75 4.64546 4.64543 3.75003 5.75 3.75003H8M3.75 16V18.25C3.75 19.3546 4.64543 20.25 5.75 20.25H8M16 3.75003H18.25C19.3546 3.75003 20.25 4.64546 20.25 5.75003V8.00003M20.25 16V18.25C20.25 19.3546 19.3546 20.25 18.25 20.25H16M15.25 12C15.25 13.795 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.795 8.75 12C8.75 10.2051 10.2051 8.75003 12 8.75003C13.7949 8.75003 15.25 10.2051 15.25 12Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M5.75 4.50003C5.05964 4.50003 4.5 5.05967 4.5 5.75003V8.00003C4.5 8.41424 4.16421 8.75003 3.75 8.75003C3.33579 8.75003 3 8.41424 3 8.00003V5.75003C3 4.23125 4.23122 3.00003 5.75 3.00003H8C8.41421 3.00003 8.75 3.33582 8.75 3.75003C8.75 4.16424 8.41421 4.50003 8 4.50003H5.75Z'
          fill='currentColor'
        />
        <path
          d='M15.25 3.75003C15.25 3.33582 15.5858 3.00003 16 3.00003H18.25C19.7688 3.00003 21 4.23125 21 5.75003V8.00003C21 8.41424 20.6642 8.75003 20.25 8.75003C19.8358 8.75003 19.5 8.41424 19.5 8.00003V5.75003C19.5 5.05967 18.9404 4.50003 18.25 4.50003H16C15.5858 4.50003 15.25 4.16424 15.25 3.75003Z'
          fill='currentColor'
        />
        <path
          d='M3.75 15.25C4.16421 15.25 4.5 15.5858 4.5 16V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H8C8.41421 19.5 8.75 19.8358 8.75 20.25C8.75 20.6642 8.41421 21 8 21H5.75C4.23122 21 3 19.7688 3 18.25V16C3 15.5858 3.33579 15.25 3.75 15.25Z'
          fill='currentColor'
        />
        <path
          d='M20.25 15.25C20.6642 15.25 21 15.5858 21 16V18.25C21 19.7688 19.7688 21 18.25 21H16C15.5858 21 15.25 20.6642 15.25 20.25C15.25 19.8358 15.5858 19.5 16 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V16C19.5 15.5858 19.8358 15.25 20.25 15.25Z'
          fill='currentColor'
        />
        <path
          d='M12 8.00003C9.79086 8.00003 8 9.79089 8 12C8 14.2092 9.79086 16 12 16C14.2091 16 16 14.2092 16 12C16 9.79089 14.2091 8.00003 12 8.00003Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
